'use strict';

var baseRequest = {
    apiVersion: 2,
    apiVersionMinor: 0
};

var tokenizationSpecification = {
    type: 'PAYMENT_GATEWAY',
    parameters: {
        'gateway': '',
        'gatewayMerchantId': ''
    }
};

var baseCardPaymentMethod = {
    type: 'CARD',
    parameters: {
        allowedAuthMethods: [],
        allowedCardNetworks: [],
        billingAddressRequired: true,
        billingAddressParameters: {
            format: 'FULL',
            phoneNumberRequired: true
        }
    }
};

var cardPaymentMethod = {};

var merchantInfo = {
    merchantId: ''
};
var environment;
var buttonColor;
var buttonType;
var buttonLocale;

// needed in order to use onPaymentDataChanged for US update after shipping selection
// onPaymentDataChanged cannot be used if the address is not required
var _paymentsClientNoAddress;
var _paymentsCleintAddressRequired;
function getGooglePaymentsClient (addressRequired = true) {
    if (addressRequired) {
        if (!_paymentsCleintAddressRequired) {
            // eslint-disable-next-line no-undef
            _paymentsCleintAddressRequired = new google.payments.api.PaymentsClient({
                environment: environment,
                paymentDataCallbacks: {
                    onPaymentAuthorized: onPaymentAuthorized,
                    onPaymentDataChanged: onPaymentDataChanged
                }
            });
        }
        return _paymentsCleintAddressRequired;
    } else {
        if (!_paymentsClientNoAddress) {
            // eslint-disable-next-line no-undef
            _paymentsClientNoAddress = new google.payments.api.PaymentsClient({
                environment: environment,
                paymentDataCallbacks: {
                    onPaymentAuthorized: onPaymentAuthorized
                }
            });
        }
        return _paymentsClientNoAddress;
    }
}

function getGoogleIsReadyToPayRequest () {
    return Object.assign(
        {
            allowedPaymentMethods: [baseCardPaymentMethod]
        },
        baseRequest
    );
}

var transInfo = {
    countryCode: '',
    currencyCode: '',
    totalPriceStatus: 'FINAL',
    totalPrice: ''
};
function getGoogleTransactionInfo () {
    return transInfo;
}

function updateTransactionInfo () {
    $('body').on('checkout:updateCheckoutView googlePay:updateTransactionDetails', function () {
        var updateUrl = $('#google-pay-btn-container').data('updateUrl');
        $.ajax({
            url: updateUrl,
            method: 'POST',
            success: function (data) {
                if (data.error) {
                    return;
                }
                transInfo = data.transactionDetails;
            }
        });
    });
}

function isInExpressCheckout () {
    return $('.page').data('action') === 'Cart-Show' ||
            (
                $('.page').data('action') === 'Checkout-Begin' &&
                $('#checkout-main').attr('data-checkout-stage') === 'shipping'
            );
}

function getGooglePaymentDataRequest () {
    var isExpressCheckout = isInExpressCheckout();
    var isCourierShippingSelectedForExpress = false;
    if (isExpressCheckout) {
        var selectedShipping = $('.shipping-method.js-shipping-types-express.shipping-method-selected');
        isCourierShippingSelectedForExpress = selectedShipping.data('shippingType') === 'courier';
    }
    var isShippingRequired;
    var isBillingRequired;
    // shipping address is needed only in the express flow when a courier shipping method is selected
    // billing address is needed only in the express flow
    if (isExpressCheckout) {
        isShippingRequired = isCourierShippingSelectedForExpress;
        isBillingRequired = true;
    } else {
        isShippingRequired = false;
        isBillingRequired = false;
    }
    var paymentDataRequest = Object.assign({}, baseRequest);
    paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
    paymentDataRequest.transactionInfo = getGoogleTransactionInfo();
    paymentDataRequest.merchantInfo = merchantInfo;
    paymentDataRequest.shippingAddressRequired = isShippingRequired;
    if (isShippingRequired) {
        paymentDataRequest.shippingAddressParameters = {
            allowedCountryCodes: [transInfo.countryCode]
        };
        paymentDataRequest.callbackIntents = ['PAYMENT_AUTHORIZATION', 'SHIPPING_ADDRESS'];
    } else {
        paymentDataRequest.callbackIntents = ['PAYMENT_AUTHORIZATION'];
    }
    paymentDataRequest.allowedPaymentMethods[0].parameters.billingAddressRequired = isBillingRequired;
    paymentDataRequest.emailRequired = true;
    return paymentDataRequest;
}

function prefetchGooglePaymentData () {
    var paymentDataRequest = getGooglePaymentDataRequest();
    // transactionInfo must be set but does not affect cache
    paymentDataRequest.transactionInfo = getGoogleTransactionInfo();
    var paymentsClient = getGooglePaymentsClient();
    paymentsClient.prefetchPaymentData(paymentDataRequest);
}

function onGooglePayLoaded () {
    var data = window.initialGPayConfig;
    if (data.error) {
        hideGooglePayPaymentMethods();
        return;
    }
    copyConfiguration(data);
    var paymentsClient = getGooglePaymentsClient();
    paymentsClient.isReadyToPay(getGoogleIsReadyToPayRequest())
        .then(function (response) {
            if (response.result) {
                addGooglePayButton();
                prefetchGooglePaymentData();
                updateTransactionInfo();
            } else {
                hideGooglePayPaymentMethods();
            }
        })
        .catch(function (err) {
            console.error(err);
            hideGooglePayPaymentMethods();
        });
}

function addGooglePayButton () {
    var paymentsClient = getGooglePaymentsClient();
    if (document.getElementById('google-pay-btn-container')) {
        var button = paymentsClient.createButton({
            buttonColor: buttonColor,
            buttonType: buttonType,
            buttonLocale: buttonLocale,
            onClick: onGooglePaymentButtonClicked,
            allowedPaymentMethods: [baseCardPaymentMethod]
        });
        document.getElementById('google-pay-btn-container').appendChild(button);
    }
}

function onGooglePaymentButtonClicked () {
    var isExpressFlow = isInExpressCheckout();
    if (isExpressFlow) {
        var canStartExpressUrl = $('#google-pay-btn-container').data('canStartExpress');
        $.spinner().start();
        $.ajax({
            url: canStartExpressUrl,
            method: 'POST',
            success: function (data) {
                if (data.error) {
                    if (data.inventoryError) {
                        showInventoryError();
                    }
                } else {
                    openPaymentSheet();
                }
            },
            complete: function () {
                $.spinner().stop();
                $('body').trigger('googlepay:sheet-open');
                $('body').trigger('analytics:paymentFastCheckout', {
                    method: 'google_pay'
                });
            }
        });
    } else {
        openPaymentSheet();
    }
    localStorage.setItem('selectedPaymentMethod', 'GOOGLEPAY');
}

function openPaymentSheet () {
    var paymentDataRequest = getGooglePaymentDataRequest();
    paymentDataRequest.transactionInfo = getGoogleTransactionInfo();
    var isShippingRequired = paymentDataRequest.shippingAddressRequired;
    var paymentsClient = getGooglePaymentsClient(isShippingRequired);
    paymentsClient.loadPaymentData(paymentDataRequest);
}

function onPaymentAuthorized (paymentData) {
    return new Promise(function (resolve, reject) {
        if (isInExpressCheckout()) {
            $.spinner().start();
            var submitTokenUrl = $('#google-pay-btn-container').data('submitTokenUrl');
            $.ajax({
                url: submitTokenUrl,
                method: 'POST',
                data: {paymentData: JSON.stringify(paymentData)},
                success: function (data) {
                    if (data.error) {
                        resolve({transactionState: 'ERROR'});
                    } else {
                        resolve({transactionState: 'SUCCESS'});
                        window.location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    resolve({transactionState: 'ERROR'});
                    $.spinner().stop();
                }
            });
        } else {
            resolve({transactionState: 'SUCCESS'});
            $('#googlePayTokenInBilling').val(paymentData.paymentMethodData.tokenizationData.token);
            $('button.submit-payment').first().trigger('click');
        }
    });
}

function onPaymentDataChanged (intermediatePaymentData) {
    return new Promise(function (resolve, reject) {
        let shippingAddress = intermediatePaymentData.shippingAddress;
        var updateData = {};
        if (shippingAddress && transInfo.countryCode === 'US') {
            updateData = {shippingAddress: JSON.stringify(shippingAddress)};
        }
        let paymentDataRequestUpdate = {};
        var updateUrl = $('#google-pay-btn-container').data('updateUrl');
        $.ajax({
            url: updateUrl,
            method: 'POST',
            data: updateData,
            success: function (data) {
                if (data.error) {
                    return;
                }
                transInfo = data.transactionDetails;
                paymentDataRequestUpdate.newTransactionInfo = transInfo;
                resolve(paymentDataRequestUpdate);
            }
        });
    });
}

function hideGooglePayPaymentMethods () {
    $('.js-google-pay-container').hide();
    $('.drawer[data-method-id="GOOGLEPAY"]').remove();
}

function showInventoryError () {
    var container = $('.page').data('action') === 'Cart-Show' ? $('.js-cart-error-reserve') : $('.js-reserve-error-checkout');
    container
        .show()
        .find('.error-message-text')
        .text(container.data('inventoryMessage'));
    $('html, body').animate({ scrollTop: 0 });
}

function copyConfiguration (data) {
    tokenizationSpecification.parameters.gateway = data.gateway;
    tokenizationSpecification.parameters.gatewayMerchantId = data.gatewayMerchantId;
    baseCardPaymentMethod.parameters.allowedCardNetworks = data.allowedCardNetworks;
    baseCardPaymentMethod.parameters.allowedAuthMethods = data.allowedCardAuthMethods;
    cardPaymentMethod = Object.assign(
        {tokenizationSpecification: tokenizationSpecification},
        baseCardPaymentMethod
    );
    environment = data.environment;
    if (data.merchantName) {
        merchantInfo.merchantName = data.merchantName;
    }
    merchantInfo.merchantId = data.merchantId;
    buttonColor = data.buttonColor;
    buttonType = data.buttonType;
    buttonLocale = data.buttonLocale;
    transInfo = data.transactionDetails;
}

window.onGooglePayLoaded = onGooglePayLoaded;
if (window.googlePayScriptAlreadyLoaded) {
    onGooglePayLoaded();
}
